import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import GEGInfo from "../components/geg_info.tsx";
import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";
import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalFassadeFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

    const fassade_future = useStore((state)=>state.fassade_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("facade_insulation",fassade_future);
    },[fassade_future]);

  return (<Panel >
            <h1>Welche neue Fassadendämmung ist geplant?</h1>
            <GEGInfo GEG={0.24} BEG={0.20}/>
            
            <PropertyInput type="fassade_future"/>
            <PropertyInput type="fassade_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["facade_insulation"].total_costs)  + " €"}/>
            <PropertyInput type="fassade_isfp"/>

           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("fassade_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

